import React from 'react'
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import { ENTER, HIVEBOARD } from '../assets/constants/Constants';
import useGeoLocation from "react-ipgeolocation";
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LS_CUSTOMER } from '../assets/constants/BrowserStorageKeys';

const CustomMobileInput = ({handleSetMobile,value,handleKeyDown,hasError,disabled,autoFocus, text}) => {
    const { t } = useTranslation();
    const location = useGeoLocation();
    const customer = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER);

    const detectedCountry = location?.country?.toLowerCase();
    const defaultCountry = detectedCountry && detectedCountry !== 'io' ? detectedCountry : 'in';

    const handleKeyEvents = (event) => {
        if(event.key === ENTER){
            if(!disabled){
                handleKeyDown();
                event.target.blur()
            }
        }
    };

    return (
       <>
       {customer !== HIVEBOARD &&
        <p className='phone-paragraph'>{text ? text : ''}</p> }
        <PhoneInput
        country={defaultCountry}
        value={value}
        inputClass={`phoneInput ${hasError ? 'error-border' : ''}`}
        dropdownStyle={{color : 'black'}}
        specialLabel=''
        placeholder={t('enterMobileNumber')}
        onChange={handleSetMobile}
        countryCodeEditable={false}
        onKeyDown={(event) => handleKeyEvents(event)}
        inputProps={{
        autoFocus: autoFocus,
        }}
        />
       </>
        
  )
}

export default CustomMobileInput;
